import React from "react";
import Layout from "../Component/Layout";
import AllTransactionsHeader from "../Component/AllTransactionsHeader";
import AllTransactionBody from "../Component/AllTransactionBody";
import Pagination from "../Component/Pagination";

function AllTransactions() {
  return (
    <Layout>
      <AllTransactionsHeader />
      <AllTransactionBody />
      <Pagination />
    </Layout>
  );
}

export default AllTransactions;
